import { Component } from '@angular/core';

@Component({
  selector: 'app-publication-rule',
  templateUrl: './publication-rule.component.html',
  styleUrls: ['./publication-rule.component.css'],
})
export class PublicationRuleComponent {}
